import React from 'react';
import Grid from '@techsoftware/happay-widgets/Grid';
import FileUpload from '@techsoftware/happay-widgets/FileUpload';
import Icons from '@techsoftware/happay-widgets/FontIcon';
import { withRouter } from 'react-router-dom';
import {
  formatDate,
  isMobile,
} from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import BottomActions from '../../bottomActions';
import GenericHeader from '../../../containers/GenericHeaderContainer';
import InvoiceDetail from '../DetailView';
import ContainerView from '../../ContainerView';
import ErrorPrompt from '../ErrorPrompt';
import ActionConfirmation from '../../ActionConfirmation';
import InvoiceShimmer from '../InvoiceShimmer';
import EditVendorDetails from './EditVendorDetail';
import EditInvoiceDetail from './EditInvoiceDetail';
import EditAmountDetails from './EditAmountDetail';
import Declaration from '../../customComponent/declaration';
import emptyStateImage from '../../../assets/images/upload-icon.svg';
import ErrorEmptyStateImage from '../../../assets/images/error-upload-icon.svg';
import CreateVendorPopup from './CreateVendorPopup';
import OCRImage from '../../../assets/images/p-icon-ocr.svg';
import { invoiceScheduleAfterPaymentTime } from '../../../utils/common';

const ocrImg = <img src={OCRImage} className="height-18" alt="ocr-scanned" />;
const supportedFileTypes = [
  'pdf',
  'heic',
  'jpg',
  'jpeg',
  'png',
  'tiff',
  'tif',
  'bmp',
];
class CreateInvoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vendor: '',
      currency: '',
      searchText: '',
      description: '',
      invoiceID: '',
      amount: '',
      gstPercentage: null,
      tdsPercentage: null,
      isGstApplicable: false,
      isTdsApplicable: false,
      gstType: 'percentage',
      tdsType: 'percentage',
      openDialogbox: false,
      // typeOfAction: '',
      showCancelConfirmation: false,
      file: {
        oldFiles: [],
        newFiles: [],
        deletedFiles: [],
      },
      error: {
        vendorError: '',
        invoiceDateError: '',
        invoiceIDError: '',
        descriptionError: '',
        invoiceDueDateError: '',
        amountError: '',
        gstError: '',
        tdsError: '',
        file: false,
      },
      shimmer: false,
      ocrScan: {
        vendor: false,
        currency: false,
        description: false,
        invoiceID: false,
        amount: false,
        invoiceDate: false,
        invoiceDueDate: false,
        discount: false,
        totalPayable: false,
        gst: false,
        tds: false,
      },
      filesToScan: [],
    };
    this.containerParam = {};
  }

  componentDidMount() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const {
      getVendorList,
      getCurrencyList,
      getInvoiceDetails,
      getWorkFlowDetails,
      match: { params: { invoiceId } = {} } = {},
      location: { state = {} },
    } = this.props;
    getVendorList();
    getCurrencyList();
    if (invoiceId) {
      if (state.urlType) {
        const params = {};
        if (state.urlType === 'RESOURCE_DETAILS') {
          params.container = state.containerType;
          params.resource_id = invoiceId;
        }
        getWorkFlowDetails({ id: invoiceId, url: state.urlType, params });
      } else {
        getInvoiceDetails({ id: invoiceId });
      }
    }
  }

  componentWillUnmount() {
    const { setInvoiceDetails, updateFiles } = this.props;
    setInvoiceDetails({});
    updateFiles([]);
  }

  componentDidUpdate(prevProps) {
    const {
      invoiceDetails: { invoice: { invoice_id: invoiceId } = {} } = {},
    } = prevProps;

    const {
      invoiceDetails: { invoice = {} } = {},
      currencyList: { currency_list = [] } = {},
      ocrData = {},
      billsUrl = [],
      vendorList = [],
      updateCount,
    } = this.props;

    const {
      invoiceDetails: { invoice: { invoice_id } = {} } = {},
    } = this.props;

    const { error } = this.state;

    if (invoice_id && invoiceId !== invoice_id && vendorList.length) {
      const {
        currency,
        vendor_details: { vendor = '' } = {},
        invoice_ref_id,
        attachments,
        amount,
        description,
        invoice_date = '',
        payment_date,
        amount_breakdown: {
          discount,
          tax_type,
          tds_type,
          tax_amount,
          tds_amount,
        } = {},
      } = invoice;

      if (
        payment_date &&
        invoiceScheduleAfterPaymentTime(new Date(payment_date))
      ) {
        error.invoiceDueDateError =
          'Please re-schedule the payment scheduled date.';
      }

      this.setState({
        vendor,
        currency: currency_list.find(el => el.alpha_code === currency)
          ?.currency_code,
        invoiceID: invoice_ref_id,
        description,
        amount,
        discount,
        invoiceDate: invoice_date ? new Date(invoice_date) : '',
        invoiceDueDate: payment_date ? new Date(payment_date) : '',
        gstPercentage: tax_amount,
        tdsPercentage: tds_amount,
        isGstApplicable: tax_amount > 0,
        isTdsApplicable: tds_amount > 0,
        gstType: tax_type,
        tdsType: tds_type,
        file: {
          oldFiles: [...attachments],
          newFiles: [],
          deletedFiles: [],
        },
        shimmer: false,
        fileShimmer: false,
        error,
      });
    } else if (
      updateCount !== prevProps.updateCount &&
      currency_list.length > 0 &&
      vendorList.length > 0
    ) {
      const {
        invoice_id = '',
        merchant_info = {},
        customer_info = {},
        currency = {},
        gross_amount = '',
        amounts_found = {},
        invoice_date = '',
        tax_info: { tax_1: { percentage = '' } = {} } = {},
      } = ocrData || {};

      const gstValue = percentage?.replace('%', '');

      let { ocrScan } = this.state;
      const {
        vendor: selectedVendor,
        currency: selectedCurrency,
        amount: selectedAmount,
        invoiceDate: selectedInvoiceDate,
        invoiceID: selectedInvoiceId,
        gstPercentage: selectedGST,
        tdsPercentage: selectedTDS,
        discount: selectedDiscount,
      } = this.state;

      const vendor = vendorList.find(el =>
        [merchant_info.gstin, customer_info.gstin].includes(
          el.identification_id,
        ),
      );

      if (Object.keys(ocrData).length) {
        ocrScan = {
          vendor: selectedVendor ? false : !!vendor?.vendor_name,
          currency: selectedCurrency ? false : !!currency.code,
          invoiceID: selectedInvoiceId ? false : !!invoice_id,
          amount: selectedAmount ? false : !!gross_amount,
          invoiceDate: selectedInvoiceDate ? false : !!invoice_date,
          discount: selectedDiscount ? false : !!amounts_found?.discount,
          totalPayable: !!gross_amount,
          gstPercentage: selectedGST ? false : !!percentage,
          isGstApplicable: !!percentage,
        };
      }

      this.setState({
        vendor: selectedVendor || vendor,
        currency: selectedCurrency || currency.code,
        amount: selectedAmount || gross_amount,
        discount: selectedDiscount || amounts_found.discount,
        invoiceDate:
          selectedInvoiceDate || (invoice_date ? new Date(invoice_date) : null),
        gstPercentage: selectedGST || gstValue,
        tdsPercentage: selectedTDS,
        isGstApplicable: !!gstValue,
        invoiceID: selectedInvoiceId || invoice_id,
        file: {
          oldFiles: [...billsUrl],
          newFiles: [],
          deletedFiles: [],
        },
        shimmer: false,
        fileShimmer: false,
        ocrScan,
        error: {},
      });
    }
  }

  handleChange = (type, val) => {
    let { tdsPercentage, gstPercentage, error, ocrScan } = this.state;
    if (['isTdsApplicable', 'tdsType'].includes(type)) {
      tdsPercentage = '';
      error.tdsError = '';
    } else if (['isGstApplicable', 'gstType'].includes(type)) {
      gstPercentage = '';
      error.gstError = '';
    } else if (type === 'gstPercentage') {
      error.gstError = '';
    } else if (type === 'tdsPercentage') {
      error.tdsError = '';
    } else if (type === 'declaration') {
      error.declaration = '';
    } else {
      error[`${type}Error`] = '';
    }
    ocrScan[type] = false;
    this.setState({
      tdsPercentage,
      gstPercentage,
      [type]: val,
      showCancelConfirmation: true,
      error,
      ocrScan,
    });
  };

  onUploadFile = (f, msg) => {
    const { openSnackbar, getData, billsUrl = [] } = this.props;
    let {
      error,
      filesToScan = [],
      file = {},
      fileShimmer,
      shimmer,
    } = this.state;
    let tempFile = [];
    if (f === false) {
      openSnackbar({
        message: msg,
        type: 'error',
      });
    } else {
      const isSupportedFileType = f.every(el =>
        supportedFileTypes.includes(
          el.name.split('.')[el.name.split('.').length - 1],
        ),
      );
      if (!isSupportedFileType) {
        this.props.openSnackbar({
          message: 'Unsupported file found',
          type: 'error',
        });
        return false;
      }
      const fileObj = new FormData();
      const ocrFileObj = new FormData();
      const txn_attachments = [];
      const ocr_attachments = [];
      for (let i = 0; i < f.length; i++) {
        fileObj.append(`file-${i}`, f[i]);
        txn_attachments.push(`file-${i}`);
      }

      fileObj.append('txn_attachments', txn_attachments);
      fileObj.append('source', 'SmartScan');
      // getS3Attachment(fileObj);

      if (filesToScan.length < 1) {
        ocr_attachments.push('file-0');
        ocrFileObj.append('txn_attachments', ocr_attachments);
        ocrFileObj.append(`file-0`, f[0]);
        ocrFileObj.append('source', 'SmartScan');
        // setTimeout(() => {
        //   getOCRData(ocrFileObj);
        // });
      }

      if (billsUrl.length) {
        // after first load
        tempFile = f;
        shimmer = false;
      } else if (f.length > 1) {
        tempFile = f.splice(1);
        shimmer = true;
      } else {
        shimmer = true;
      }

      getData(fileObj, shimmer ? ocrFileObj : null);

      // OCR data

      error.file = false;
      this.setState({
        // file,
        error,
        shimmer,
        fileShimmer: true,
        filesToScan: [...filesToScan, ...tempFile],
        showCancelConfirmation: true,
      });
    }
  };

  onDeleteFile = (index, type) => {
    const { file } = this.state;
    const { updateFiles, getData, billsUrl } = this.props;
    let { filesToScan, shimmer = false, ocrScan } = this.state;
    if (type === 'oldFiles') {
      file.oldFiles = file.oldFiles.filter((f, i) => i !== index);
    }
    if (index === 0 && filesToScan.length) {
      const ocrFileObj = new FormData();
      const ocr_attachments = [];
      ocr_attachments.push('file-0');
      ocrFileObj.append('txn_attachments', ocr_attachments);
      ocrFileObj.append(`file-0`, filesToScan[0]);
      ocrFileObj.append('source', 'SmartScan');
      getData(null, ocrFileObj, `${index}`);
      // getOCRData(ocrFileObj, `${index}`);
      shimmer = true;
    } else {
      updateFiles(file.oldFiles, index);
    }

    if (index === 0) {
      filesToScan = filesToScan.filter((f, i) => i !== index);
      // Check for the OCR scanned data, and if file is deleted all the OCR scanned data should be empty
      for (const key in ocrScan) {
        if (ocrScan[key]) {
          this.state[key] = key === 'isGstApplicable' ? false : '';
        }
      }
    } else {
      filesToScan = filesToScan.filter((f, i) => i !== index - 1);
    }

    this.setState({
      ...this.state,
      file,
      shimmer,
      filesToScan,
    });
  };

  drawCardUI = (cardTitle, cardIndex, cardContent) => (
    <ContainerView
      cardTitle={cardTitle}
      cardContent={cardContent}
      cardIndex={cardIndex}
      className="margin-b-20"
    />
  );

  getCurrency = () => {
    const { currencyList: { org_currency = {} } = {} } = this.props;
    const { currency } = this.state;

    return currency || org_currency?.default_curr;
  };

  getHeaderConfig = () => {
    const {
      match: { params: { viewType } = {} } = {},
      invoiceDetails: { invoice: { editable } = {} } = {},
    } = this.props;

    const obj = {};

    if (viewType === 'detail' && editable) {
      obj.edit = {
        name: '',
        id: 11,
        type: 'edit',
      };
    }
    if (viewType === 'detail' && editable) {
      obj.delete = {
        name: '',
        id: 11,
        type: 'delete',
      };
    } else {
      obj.limitInfo = {
        name: '',
        id: 11,
        type: 'limitInfo',
      };
    }
    return obj;
  };

  onButtonClick = (event, type) => {
    const {
      history,
      match: { params: { invoiceId } = {} } = {},
      updateInvoiceDetails,
    } = this.props;
    if (type.type === 'crossButton') {
      history.goBack();
    }
    if (type.type === 'edit') {
      history.push(`/invoice/myinvoice/editinvoice/${invoiceId}`);
    }
    if (type.type === 'delete') {
      this.setState({ openDialogbox: true });
    }
  };

  handleDialogActionClick = val => {
    const {
      updateInvoiceDetails,
      match: { params: { invoiceId } = {} } = {},
    } = this.props;
    const finalObj = new FormData();
    finalObj.append('id', invoiceId);
    finalObj.append('delete_flag', true);
    updateInvoiceDetails(finalObj);
    this.setState({ openDialogbox: false });
  };

  getPayableAmount = () => {
    const { amount, discount } = this.state;
    const gstVal = this.getGSTVal();
    const tdsVal = this.getTDSVal();

    const amt = +amount + (gstVal - tdsVal) - +(discount || 0) || '';

    return amount && !amt
      ? 0
      : !amt || Number.isInteger(amt)
      ? amt
      : (+amt)?.toFixed(2);
  };

  getTDSVal = () => {
    const { amount, tdsType, tdsPercentage, discount = 0 } = this.state;
    return tdsType === 'percentage'
      ? (+(amount - discount) * tdsPercentage || 0) / 100 || 0
      : +tdsPercentage;
  };

  getGSTVal = () => {
    const { amount, gstType, gstPercentage, discount = 0 } = this.state;
    return gstType === 'percentage'
      ? (+(amount - discount) * gstPercentage || 0) / 100 || 0
      : +gstPercentage;
  };

  handleScroll = id => {
    const element = document.querySelector(id);
    if (id && element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
    }
  };

  appendData = finalObj => {
    const {
      vendor,
      invoiceDate,
      invoiceDueDate,
      amount,
      invoiceID,
      discount,
      description,
      gstType,
      tdsType,
      gstPercentage,
      tdsPercentage,
    } = this.state;

    const amountBreakDown = {
      base_amount: amount,
      tax_amount: gstPercentage,
      tds_amount: tdsPercentage,
      discount,
      tax_type: gstType,
      tds_type: tdsType,
    };

    finalObj.append('vendor_id', vendor.vendor_id || '');
    finalObj.append('invoice_date', formatDate(invoiceDate, 'YYYY-MM-DD'));
    finalObj.append('due_date', formatDate(invoiceDueDate, 'YYYY-MM-DD'));
    finalObj.append('currency', this.getCurrency());
    finalObj.append('amount', amount);
    finalObj.append('payable_amount', this.getPayableAmount());
    finalObj.append('display_name', vendor.display_name || '');
    finalObj.append('invoice_ref_id', invoiceID);
    finalObj.append('amount_breakdown', JSON.stringify(amountBreakDown));
    finalObj.append('description', description);
  };

  createParams = () => {
    const {
      file: { oldFiles = [] },
    } = this.state;
    const finalObj = new FormData();
    finalObj.append('attachment_list', JSON.stringify([...oldFiles]));
    this.appendData(finalObj);
    return finalObj;
  };

  createUpdateParams = () => {
    const {
      invoiceDetails: { invoice: { invoice_id, attachments = [] } } = {},
    } = this.props;
    const {
      file: { newFiles = [], oldFiles = [] },
    } = this.state;

    const finalObj = new FormData();

    const deletedItem = [];
    for (let i = 0; i < attachments.length; i++) {
      if (!oldFiles?.includes(attachments[i])) {
        deletedItem.push(i);
      }
    }

    let count = 0;
    for (let j = 0; j < newFiles.length; j++) {
      if (deletedItem[j] === 0 || deletedItem[j]) {
        finalObj.append(`attachment_${deletedItem[j]}`, newFiles[j]);
      } else {
        count = count === 0 ? attachments.length : count + 1;
        finalObj.append(`attachment_${count}`, newFiles[j]);
      }
    }

    if (deletedItem.length) {
      finalObj.append(`delete_item`, JSON.stringify(deletedItem));
    }

    this.appendData(finalObj);

    finalObj.append('id', invoice_id);
    return finalObj;
  };

  handleActionClick = typeOfAction => {
    const {
      saveInvoiceDetails,
      updateInvoiceDetails,
      match: { params: { viewType } = {} } = {},
      openSnackbar,
      invoiceDetails: { invoice: { invoice_id = '' } = {} } = {},
    } = this.props;
    const isValidated = this.checkValidation(typeOfAction);

    if (!this.getPayableAmount()) {
      openSnackbar({
        message: 'Total invoice amount cannot be zero',
        type: 'error',
      });
      return -1;
    }

    if (
      isValidated &&
      ['Submit', 'Save'].includes(typeOfAction) &&
      viewType !== 'editinvoice'
    ) {
      if (invoice_id) {
        this.submitInvoice();
      } else {
        saveInvoiceDetails(this.createParams(), typeOfAction === 'Submit');
      }
    } else if (isValidated && viewType === 'editinvoice') {
      // this.createUpdateParams()
      updateInvoiceDetails(
        this.createUpdateParams(),
        typeOfAction === 'Submit',
      );
    }
  };

  submitInvoice = otp => {
    const {
      invoiceDetails: { invoice: { invoice_id } = {} } = {},
      submitInvoice,
    } = this.props;
    const param = {
      invoice_id,
    };
    if (otp) {
      param.otp = otp;
      param.invoice_fee_accept = true;
    }
    submitInvoice(param);
  };

  checkValidation = typeOfAction => {
    const {
      vendor,
      invoiceDate,
      invoiceDueDate,
      amount,
      description,
      invoiceID,
      isGstApplicable,
      isTdsApplicable,
      file: { newFiles = [], oldFiles = [] },
      error,
      declaration,
      tdsPercentage,
      gstPercentage,
    } = this.state;
    let checkPass = true;
    let errorEle = null;
    if (!declaration && typeOfAction !== 'Save') {
      errorEle = '#invoice-declaration';
      error.declaration = true;
      checkPass = false;
    }
    if (isTdsApplicable && !tdsPercentage && !this.getTDSVal()) {
      error.tdsError = 'Please enter TDS Percentage';
      errorEle = '#tds-value';
      checkPass = false;
    }
    if (isGstApplicable && !gstPercentage && !this.getGSTVal()) {
      error.gstError = 'Please enter GST Percentage';
      errorEle = '#gst-value';
      checkPass = false;
    }
    if (!amount) {
      error.amountError = 'Please enter gross amount';
      errorEle = '#invoice-amount';
      checkPass = false;
    }
    if (!invoiceDueDate && invoiceDate) {
      error.invoiceDueDateError = 'Please select invoide due date';
      errorEle = '#invoice-due-date';
      checkPass = false;
    }
    if (invoiceScheduleAfterPaymentTime(invoiceDueDate)) {
      error.invoiceDueDateError =
        'Please re-schedule the payment scheduled date.';
      errorEle = '#invoice-due-date';
      checkPass = false;
    }
    if (!description) {
      error.descriptionError = 'Please enter description';
      errorEle = '#invoice-description';
      checkPass = false;
    }
    if (!invoiceID) {
      error.invoiceIDError = 'Please enter invoice ID';
      errorEle = '#invoice-id';
      checkPass = false;
    }
    if (!invoiceDate) {
      error.invoiceDateError = 'Please select invoice date';
      errorEle = '#invoice-date';
      checkPass = false;
    }
    if (!vendor) {
      error.vendorError = 'Please select vendor';
      errorEle = '#select-vendor-name-dropdown';
      checkPass = false;
    }
    if (newFiles.length === 0 && oldFiles.length === 0) {
      error.file = true;
      checkPass = false;
    }
    if (+this.getPayableAmount() < 0) {
      error.payableAmountError = 'Payable amount should not be less than 0';
      errorEle = '#invoice-payable-amount';
      checkPass = false;
    }
    if (!checkPass) {
      this.handleScroll(errorEle);
      this.setState({ error });
    }
    return checkPass;
  };

  callWorkflowContainerAction = (
    param,
    commentParam,
    otp,
    scheduleDateParam,
  ) => {
    const { workflowContainerAction } = this.props;
    this.containerParam = param;
    const tempParam = param;
    if (otp) {
      tempParam.otp = otp;
      tempParam.invoice_fee_accept = true;
    }
    workflowContainerAction(tempParam, commentParam, scheduleDateParam);
  };

  saveAndSubmitInvoice = (newScheduledate, id) => {
    const { updateInvoiceDetails } = this.props;
    const finalParam = this.createUpdateParams();
    finalParam.append('due_date', formatDate(newScheduledate, 'YYYY-MM-DD'));
    updateInvoiceDetails(finalParam, true);
  };

  render() {
    const {
      vendorList,
      currencyList: { currency_list = [], org_currency = {} } = {},
      history,
      match: { params: { viewType } = {} } = {},
      invoiceDetails = {},
      workflowDetails = {},
      invoicePromptError,
      generateOTP,
      invoiceSubmitConfirmation,
      location: { state = {} },
      getWorkflowComments,
      comment,
      userInfo = {},
      ocrError = '',
      setInvoicePromptError,
      rescheduleInvoice,
      cancelPayment,
      walletLimit,
    } = this.props;
    const {
      declaration,
      file,
      error = {},
      openDialogbox,
      showCancelConfirmation,
      shimmer,
      fileShimmer,
    } = this.state;
    const dropdownCurrencyList = currency_list.map(item => ({
      ...item,
      text: item.alpha_code,
      value: item.currency_code,
    }));
    const defaultCurrency = org_currency?.default_curr;
    const showShimmer = Object.keys(invoiceDetails).length === 0;
    const {
      invoice: {
        vendor_details: { vendor: { is_gstin_flow } = {} } = {},
        approval_status: approvalStatus = {},
      } = {},
    } = invoiceDetails;

    const { oldFiles = [], newFiles = [] } = file;

    const isFilePresent = oldFiles.length + newFiles.length > 0;

    return (
      <>
        <GenericHeader
          title={
            viewType === 'detail'
              ? 'Invoice Details'
              : viewType === 'editinvoice'
              ? 'Edit Invoice'
              : 'New Invoice'
          }
          showBreadcrumbs={false}
          headerconfig={this.getHeaderConfig()}
          onButtonClick={this.onButtonClick}
          from="invoice"
          showStatus={viewType == 'detail'}
          data={{
            ...approvalStatus,
            name: workflowDetails.is_blocked
              ? 'Request in process'
              : approvalStatus?.name,
          }}
        />
        <Grid
          container
          alignItems="flex-start"
          justify="space-evenly"
          className="create-vendor-container padding-b-100 padding-lr-70"
        >
          <Grid
            container
            justify="flex-start"
            alignItems={isMobile ? 'center' : 'flex-start'}
            item
            xs={24}
            sm={24}
            md={24}
            xl={24}
            lg={24}
          >
            <ActionConfirmation
              btn2Action={this.handleDialogActionClick}
              openDialogbox={openDialogbox}
              onDialogboxClose={() => this.setState({ openDialogbox: false })}
              dialogTitle="Delete Invoice"
              dialogBody="Are you sure you want to delete the invoice?"
            />
            {['detail', 'editinvoice'].includes(viewType) && showShimmer ? (
              <InvoiceShimmer />
            ) : viewType === 'detail' ? (
              <InvoiceDetail
                invoiceDetails={invoiceDetails}
                viewType={viewType}
                workflowDetails={workflowDetails}
                workflowContainerAction={this.callWorkflowContainerAction}
                submitInvoice={this.submitInvoice}
                from={state.urlType ? 'workflow' : 'nonworkflow'}
                getWorkflowComments={getWorkflowComments}
                comment={comment}
                currencyList={dropdownCurrencyList}
                userInfo={userInfo}
                rescheduleInvoice={rescheduleInvoice}
                cancelPayment={cancelPayment}
                saveAndSubmitInvoice={this.saveAndSubmitInvoice}
              />
            ) : (
              <>
                <Grid
                  item
                  className={`${
                    isMobile ? '' : 'margin-t-118'
                  } invoice-upload-container ${error.file ? 'file-error' : ''}`}
                  xs={24}
                  sm={10}
                  md={10}
                  xl={10}
                  lg={10}
                >
                  <div
                    className={`pos-relative ${
                      isMobile ? 'margin-b-20' : 'margin-r-36'
                    }`}
                  >
                    <FileUpload
                      id="invoice-creation"
                      files={file}
                      uploadFiles={this.onUploadFile}
                      deleteFiles={this.onDeleteFile}
                      labelText={
                        <div className="fw-600">
                          Drag & Drop or Upload Invoice
                        </div>
                      }
                      emptyStateImage={
                        error.file ? ErrorEmptyStateImage : emptyStateImage
                      }
                      iconType="add"
                      uploadButtonText="Upload Invoice"
                      multiple
                      enableLightBox
                      variant="quaternary"
                      maxAttachment={5}
                      acceptedFiles={[
                        'application/pdf',
                        'image/heic',
                        'image/jpg',
                        'image/jpeg',
                        'image/png',
                        'image/tiff',
                        'image/tif',
                        'image/bmp',
                      ]}
                      shimmer={fileShimmer}
                      shimmerElement={
                        <div className="align-center">
                          <Icons type="scan" />
                          <h3>ScanX in progress</h3>
                          <div>We are auto-fetching the data...</div>
                        </div>
                      }
                      inplaceUploadWrapper={{ height: '600px' }}
                      dummyElementClass="icon"
                      dummyElementContainerClass={`${
                        shimmer
                          ? ''
                          : `dummyelement ${
                              ocrError ? 'error icon' : 'success'
                            }`
                      }`}
                      info={
                        <div
                          style={{
                            width: isFilePresent ? '300px' : '',
                          }}
                          className={`align-left grey-darker-color font-12 ${
                            isFilePresent ? 'padding-10' : ''
                          }`}
                        >
                          *Max. file upload: 5 files in PNG, JPG, PDF format
                          *Max. file size: 15Mb
                          <br /> *Scan X will only scan the first file
                        </div>
                      }
                      errorText={
                        ocrError && (
                          <Grid
                            contaner
                            justify="flex-start"
                            alignItems="flex-start"
                            className="d-flex"
                          >
                            <Icons
                              type="info"
                              className="margin-r-6"
                              size="small"
                            />
                            <div>
                              Scan X Error: We were unable to fetch any invoice
                              details, please upload a different image or enter
                              manually.
                            </div>
                          </Grid>
                        )
                      }
                    />
                    {/* {ocrError ? (
                      <div className="pos-absolute ocr-error font-12">
                        <Icons
                          size="small"
                          type="error"
                          className="margin-r-6"
                        />
                        {ocrError}
                      </div>
                    ) : null} */}
                  </div>
                </Grid>
                <Grid
                  item
                  className="margin-t-118"
                  xs={24}
                  sm={14}
                  md={14}
                  xl={14}
                  lg={14}
                >
                  <form>
                    <div>
                      <EditVendorDetails
                        vendorList={vendorList || []}
                        {...this.state}
                        handleChange={this.handleChange}
                        drawCardUI={this.drawCardUI}
                        history={history}
                        isEditInvoice={viewType === 'editinvoice'}
                        isGstinFlow={is_gstin_flow}
                        ocrImg={ocrImg}
                      />
                      <EditInvoiceDetail
                        {...this.state}
                        handleChange={this.handleChange}
                        drawCardUI={this.drawCardUI}
                        ocrImg={ocrImg}
                      />
                      <EditAmountDetails
                        {...this.props}
                        {...this.state}
                        handleChange={this.handleChange}
                        drawCardUI={this.drawCardUI}
                        currencyList={dropdownCurrencyList}
                        defaultCurrency={defaultCurrency}
                        payableAmount={this.getPayableAmount()}
                        ocrImg={ocrImg}
                      />

                      <Declaration
                        onClick={this.handleChange}
                        id="invoice-declaration"
                        value={declaration}
                        error={error.declaration}
                        checkBoxWrapperStyle={
                          error.declaration ? { paddingBottom: '60px' } : {}
                        }
                        label="I hereby declare that the subject registered vendor is not a related party/subsidiary/associate company/sister company of the organization."
                      />
                      <BottomActions
                        handleActionClick={typeOfAction =>
                          this.handleActionClick(typeOfAction)
                        }
                        from="Invoice"
                        viewType={viewType}
                        validation={this.checkValidation}
                        actionMap={{ Save: 'Save', Submit: 'Submit' }}
                        showCancelConfirmation={showCancelConfirmation}
                      />
                    </div>
                  </form>
                </Grid>
              </>
            )}
          </Grid>
          <ErrorPrompt
            error={invoicePromptError}
            generateOTP={generateOTP}
            invoiceSubmitConfirmation={invoiceSubmitConfirmation}
            handleActionClick={otp =>
              state.urlType
                ? this.callWorkflowContainerAction(
                    this.containerParam,
                    null,
                    otp,
                  )
                : this.submitInvoice(otp)
            }
            invoiceDetails={{
              ...(invoiceDetails?.invoice || {}),
            }}
            userInfo={userInfo}
            workflow={state.urlType}
            setInvoicePromptError={setInvoicePromptError}
            walletLimit={walletLimit}
          />
          {vendorList?.length === 0 && (
            <CreateVendorPopup
              onClick={() => history.push('/vendor/myvendor/createView')}
            />
          )}
        </Grid>
      </>
    );
  }
}

export default withRouter(CreateInvoice);
